import { memo } from "react";

/**
 * Guilloché: the engraved rosette of banknotes and cheques. Each curve is a circle
 * whose radius is modulated by a sine wave; rotated copies overlap into the lattice
 * security printers use. Drawn once, as thin strokes, behind money.
 */
function rosette(cx: number, cy: number, r: number, amp: number, lobes: number, curves: number, steps = 480): string {
  let d = "";
  for (let k = 0; k < curves; k++) {
    // Phases spread over a full turn: the curves braid into a band instead of stacking.
    const phase = (k / curves) * 2 * Math.PI;
    for (let i = 0; i <= steps; i++) {
      const t = (i / steps) * 2 * Math.PI;
      const rr = r + amp * Math.sin(lobes * t + phase);
      const x = cx + rr * Math.cos(t);
      const y = cy + rr * Math.sin(t);
      d += `${i === 0 ? "M" : "L"}${x.toFixed(1)} ${y.toFixed(1)}`;
    }
  }
  return d;
}

const RINGS = [
  { r: 214, amp: 14, lobes: 36, curves: 9 },
  { r: 168, amp: 11, lobes: 28, curves: 8 },
  { r: 124, amp: 9, lobes: 21, curves: 7 },
];
const PATH = RINGS.map((g) => rosette(250, 250, g.r, g.amp, g.lobes, g.curves)).join("");

export const Guilloche = memo(function Guilloche({ className, opacity = 0.16 }: { className?: string; opacity?: number }) {
  return (
    <svg className={className} viewBox="0 0 500 500" aria-hidden="true" focusable="false">
      {/* Decorative: the pre-rendered HTML skips the ~135 KB curve; the app draws it. */}
      <path d={typeof window === "undefined" ? "" : PATH} fill="none" stroke="currentColor" strokeWidth="0.5" vectorEffect="non-scaling-stroke" opacity={opacity} />
    </svg>
  );
});
